export const imageEditorControlClass =
  "flex min-h-11 min-w-11 items-center justify-center rounded-full bg-[#2d2d2d]/90 px-3 text-white shadow-lg shadow-black/25 backdrop-blur-sm transition hover:bg-[#3a3a3a] active:scale-95 active:bg-[#444]";
